import axios from '../utils/axios';

/**
 * Fetch all cron jobs
 * @param {string} adminId - Admin ID
 * @param {Object} params - Query parameters (limit, etc.)
 * @returns {Promise} API response
 */
export default function fetchCronJobs(adminId, params = {}) {
    return axios.get(`/admin/${adminId}/cron/jobs`, { params });
}
